<div class="loading-screen" *ngIf="loading">
  <div class="loading-animation">
    <p-progressSpinner strokeWidth="8" [style]="{width: '50px', height: '50px'}">
    </p-progressSpinner>
  </div>
</div>
